{
  "validation.maxAttachments": "São permitidos apenas {{max}} anexos.",
  "validation.minAttachments": "pelo menos {{min}} anexos são obrigatórios",
  "validation.maxAttachmentSize": "Os anexos não podem passar de {{max}} megabytes.",
  "validation.attachmentListItemRequired": "Por favor, forneça um anexo para \"{{category}}",
  "validation.attachmentListItemMaxAttachments": "Só é permitido enviar até {{max}} anexos para \"{{category}}\".",
  "validation.attachmentListItemMaxAttachmentSize": "Os anexos da categoria {{category}} não podem ter mais de {{max}} megabytes.",
  "attachment.bsoCategory.DiagnosticReport": "Relatório de diagnóstico",
  "attachment.bsoCategory.InvoiceDocument": "Documento de fatura",
  "attachment.bsoCategory.ShippingDocument": "Documento de envio",
  "attachment.bsoCategory.Letter": "Carta",
  "attachment.bsoCategory.PictureReference": "Referência de imagem",
  "attachment.bsoCategory.BugReport": "Relatório de erro",
  "attachment.bsoCategory.Other": "Outro",
  "attachment.bsoCategory.Unclassified": "Não classificado",
  "attachment.bsoCategory.ServiceForms": "Formulário de serviço",
  "attachment.bsoCategory.RegistrationDocument": "Documento de registo",
  "attachment.bsoCategory.ShopInside": "Foto do interior da loja",
  "attachment.bsoCategory.ShopImageMigration": "Migração de imagens da loja",
  "attachment.bsoCategory.ShopImage": "Foto da montra da loja",
  "attachment.uploadButton": "Carregar {{category}}",
  "attachment.uploadDropdown": "Carregar um ficheiro"
}